import { FC } from 'react';

import HotelAutoComplate from '@domain/hotel/hotelAutoComplate';
import { BookerSearchViewModel } from '@components/views/landing/components/booker/common/BookerSearchDrawer';
import useSearchBar from '@contexts/searchbar';
import { HotelSearchBarActionType } from '@contexts/searchbar/types/hotel';
import { useBreakpoint } from '@contexts/breakpoints';

import { Wrapper } from './styled';
import MobileHotelSelection from './MobileHotelSelection';

interface IHotelSelection {
  history?: BookerSearchViewModel[];
  clearPastHotelSearch?: () => void;
  removePastHotelSearch?: (item: BookerSearchViewModel) => void;
  fullWidth?: boolean;
}

const HotelSelection: FC<IHotelSelection> = ({
  history,
  clearPastHotelSearch,
  removePastHotelSearch,
  fullWidth,
}) => {
  const { xl } = useBreakpoint();
  const {
    state: { hotel: state },
    dispatch,
  } = useSearchBar();
  return (
    <Wrapper $fullWidth={fullWidth}>
      {xl || xl === undefined ? (
        <HotelAutoComplate
          label='Nereye?'
          onChange={(location) =>
            dispatch({
              type: HotelSearchBarActionType.SET_LOCATION,
              payload: location,
            })
          }
          data-test='hotel-autocomplete'
          history={history}
          clearPastHotelSearch={clearPastHotelSearch}
          removePastHotelSearch={removePastHotelSearch}
          isLocationError={state.isLocationError}
          activeLocation={state.location}
          setIsLocationError={(value) =>
            dispatch({
              type: HotelSearchBarActionType.SET_IS_LOCATION_ERROR,
              payload: value,
            })
          }
        />
      ) : (
        <MobileHotelSelection
          label='Nereye?'
          onChange={(location) =>
            dispatch({
              type: HotelSearchBarActionType.SET_LOCATION,
              payload: location,
            })
          }
          data-test='hotel-autocomplete'
          history={history}
          clearPastHotelSearch={clearPastHotelSearch}
          removePastHotelSearch={removePastHotelSearch}
          isLocationError={state.isLocationError}
          activeLocation={state.location}
          setIsLocationError={(value) =>
            dispatch({
              type: HotelSearchBarActionType.SET_IS_LOCATION_ERROR,
              payload: value,
            })
          }
        />
      )}
    </Wrapper>
  );
};

export default HotelSelection;
